/**
 * Integration scope: current user's integrations and user id.
 * Used by marketplace, integrations manager, and apps panel.
 */

import { getUserId } from "@/lib/user/identity";
import { db } from "@/lib/db";
import type { Integration } from "@/types/integration";

/** Current user id (Supabase auth or local device id). */
export function getCurrentUserId(): string {
  return getUserId();
}

/** Integrations owned by the current user. Uses IndexedDB; no userId index, so filter in memory. */
export async function getIntegrationsForCurrentUser(): Promise<Integration[]> {
  if (typeof window === "undefined" || !db?.integrations) return [];
  const current = getCurrentUserId();
  const all = await db.integrations.toArray();
  return all.filter((i) => (i as Integration & { userId?: string }).userId === current || (i as Integration & { userId?: string }).userId == null);
}
